module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/create-customer/create-customer.component.css
// module id = ./src/app/create-customer/create-customer.component.css
// module chunks = main